<div class="modal-header">
    <h5 class="modal-title">Note </h5>
    <button type="button" class="close" data-dismiss="modal" (click)="closeModal('dismiss')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    

<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
               
                <div class="card-body custom-datatable noscroll">
                    <div class="custom-datatable1">
                        <!-- <h4 style="font-size: 19px;">Are you sure want to download the {{getStatus}} Pre Clearance Order PDF?</h4> -->
                        <!-- <h4 style="font-size: 19px;">Considering Limited Space available on one page, the pdf report is only for internal purposes. For complete upsi report download excel.</h4> -->
                        <h4 style="font-size: 19px;">{{title}}</h4>
                        <div class="btn-bottom">
                            <button class="btn btn-primary me-1" (click)="onFilterPdf('Yes')">Download</button>
                            <button class="btn btn-primary me-1" (click)="closeModal('close')">No</button>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
 </div>
</div>
<div class="modal-footer">
    <div class="text-muted">
        <p><b>Note: </b> Please wait a few seconds for the file to download.</p>
    </div>
    <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeModal('close')">Close</button> -->
</div>
